<template>

  <div class="w_inner">
    <div class="con_box inner_banner news wow fadeIn animated" data-wow-delay="0.0s">
      <!-- <div class="text_conShow w">
                  <div class="text_box">
                    <div class="title wow fadeInUp animated"  data-wow-delay="0.2s">{{dto.title}}</div>
                    <div class="con wow fadeInUp animated" data-wow-delay="0.4s"  v-html="utils.ShowContentBr(dto.content)">
                    </div>
                  </div>
              </div> -->
    </div>
    <div class="innerWrap">
      <div class="main_container w">
        <div class="title wow fadeInUp animated" data-wow-delay=".4s">{{ $t('news.title') }}</div>
        <div class="news_list">
          <template v-if="total == 0">
            <div class="nodataTips">{{ $t('news.tip') }}~</div>
          </template>
          <div class="list">
            <ul>
              <template v-for="(item, index) in news_list">
              <li class="clearfix" :key="index">
                <router-link :to="{ name: 'newsdetail', params: { id: item.id } }">
                  <img :src="item.imgUrl" alt="">
                  <div class="desc">
                    <div class="tishow">{{ item.title }}</div>
                    <div class="con">
                      {{ item.zhaiyao }}
                    </div>
                    <div class="pull">
                      <span class="read">{{ item.click }}</span>
                      <span class="time">{{ item.publishTime }}</span>
                    </div>
                    <div class="more"><span>{{ $t('news.view') }}</span></div>
                  </div>
                </router-link>
              </li>
              </template>
            </ul>
          </div>
          <pagination v-model="pageindex" :total="total" :pagesize="pagesize"></pagination>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import WOW from "../../node_modules/wowjs/dist/wow";
import pagination from '../components/common/Pagination.vue';
import { Loading } from 'element-ui';

export default {
  data() {
    return {

      total: 0,
      pageindex: 1,
      pagesize: 6,
      news_list: []
    }
  },
  mounted() {
    //滚动页面加载动画
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    document.documentElement.scrollTop = 0;
  },

  created: function () {
    this.GetList();
  },
  components: {

  },
  methods: {


    Initwow() {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    },
    GetList() {
      var url = "/pageapi/News/GetList";
      this.$http.post(url, { pageindex: this.pageindex, pagesize: this.pagesize }).then(function (res) {
        if (res.data.status == 1) {
          this.news_list = res.data.ds;
          this.total = res.data.total;
          this.$nextTick(function () {
            this.Initwow();
          });
        }
      }.bind(this)).catch(function () {
      });
    },
    PropsChange() {
      if (this.pageindex != 1) {
        this.pageindex = 1;
      } else {
        this.GetList();
      }
    },
  },
  watch: {
    $route(newVal, oldVal) {
      this.id = this.$route.params.id;
      this.GetCat();
      this.GetProList();
    },
    pageindex: function () {
      this.GetList();
    },
  }
};
</script>
